/**
 * FeedSidebarCard.js — EcoScienceInnova
 * Generic card wrapper for sidebar widgets.
 * Accepts a `title` and renders children inside.
 */
import React from 'react';
import './feed.shared.css';

/**
 * @param {string}    title    - Section title (uppercase label style)
 * @param {ReactNode} children - Widget content
 * @param {string}    className
 */
const FeedSidebarCard = ({ title, children, className = '' }) => {
    return (
        <div className={`feed-sidebar-card ${className}`}>
            {title && <p className="feed-sidebar-title">{title}</p>}
            {children}
        </div>
    );
};

export default FeedSidebarCard;
